import { Injectable } from "@angular/core";
import { EquipmentQuantity } from "../models/equipment-quantity.model";

@Injectable({
  providedIn: "root",
})
export class EquipmentQuantityService {
  public getEquipmentQuantityForEquipment(
    equipment,
  ): Map<string, EquipmentQuantity> {
    const equipmentQuantity = new Map<string, EquipmentQuantity>();
    for (const containerName of equipment) {
      equipmentQuantity.set(
        containerName,
        new EquipmentQuantity(containerName, 1),
      );
    }

    return equipmentQuantity;
  }
}
